"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionType = exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    /**
     * For application notifications
     */
    NotificationType["APPLICATION"] = "APPLICATION";
    /**
     * For email notifications
     */
    NotificationType["EMAIL"] = "EMAIL";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var SubscriptionType;
(function (SubscriptionType) {
    /**
     * None
     */
    SubscriptionType["NONE"] = "NONE";
    /**
     * Only application
     */
    SubscriptionType["APPLICATION"] = "APPLICATION";
    /**
     * Only email
     */
    SubscriptionType["EMAIL"] = "EMAIL";
    /**
     * Application and email
     */
    SubscriptionType["BOTH"] = "BOTH";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
//# sourceMappingURL=notification-types.js.map